export default __webpack_public_path__ + "1a223d0bdfee5468f81347e2088e4713.png";